import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.employee;

export const employeeActiveTabSelector = createSelector(
  getState,
  (state) => state.employeeActiveTab,
);
